import React, { useState } from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';

const Header = ({ location }: { location: { pathname: string } }) => {
  const [open, setOpen] = useState(false);
  const {
    file: { publicURL },
  } = useStaticQuery(graphql`
    query {
      file(name: { eq: "logo" }) {
        publicURL
      }
    }
  `);

  return (
    <header className='grid grid-cols-2 lg:grid-cols-5 pt-5 px-10 lg:px-20 z-50'>
      <div className='col-span-1 lg:col-span-3 grid'>
        <Link to='/' className='w-10 self-center'>
          <img src={publicURL} className='max-h-10 max-w-max w-10' />
        </Link>
      </div>
      <div className='col-span-1 lg:col-span-2'>
        <nav className='relative flex items-center sm:h-12 justify-end' aria-label='Global'>
          <div className='-mr-2 flex items-center md:hidden'>
            <button
              type='button'
              className='bg-white rounded-md p-2 inline-flex items-center justify-self-end text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'
              id='main-menu'
              onClick={() => setOpen((prev) => !prev)}
              aria-haspopup='true'
            >
              <span className='sr-only'>Open main menu</span>
              <svg
                className='h-6 w-6'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                aria-hidden='true'
              >
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16M4 18h16' />
              </svg>
            </button>
          </div>
          <div className='hidden md:flex gap-4'>
            <Link to='/' className={location.pathname === '/' ? 'font-bold text-accent' : ''}>
              Home
            </Link>
            <Link to='/projects' className={location.pathname.match(/\/projects/i) ? 'font-bold text-accent' : ''}>
              Projects
            </Link>
            <Link to='/contact-me' className={location.pathname === '/contact-me' ? 'font-bold text-accent' : ''}>
              Contact me
            </Link>
          </div>
        </nav>
      </div>

      <Transition
        show={open}
        enter='duration-150 ease-out'
        enterFrom='opacity-0 scale-95'
        enterTo='opacity-100 scale-100'
        leave='duration-100 ease-in'
        leaveFrom='opacity-100 scale-100'
        leaveTo='opacity-0 scale-95'
        className='absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50'
      >
        <div className=''>
          <div className='rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden'>
            <div className='px-5 pt-4 flex items-center justify-between'>
              <Link to='/'>
                <img src={publicURL} className='max-h-10 w-14'></img>
              </Link>
              <div className='-mr-2'>
                <button
                  type='button'
                  className='bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'
                  onClick={() => setOpen((prev) => !prev)}
                >
                  <span className='sr-only'>Close main menu</span>
                  <svg
                    className='h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
                  </svg>
                </button>
              </div>
            </div>
            <div role='menu' aria-orientation='vertical' aria-labelledby='main-menu'>
              <div className='px-2 pt-2 pb-3 space-y-1' role='none'>
                <Link
                  to='/'
                  className={`${
                    location.pathname === '/' ? 'font-bold text-accent' : ''
                  } block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50`}
                  role='menuitem'
                >
                  Home
                </Link>
                <Link
                  to='/projects'
                  className={`${
                    location.pathname.match(/\/projects/i) ? 'font-bold text-accent' : ''
                  } block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50`}
                  role='menuitem'
                >
                  Projects
                </Link>
                <Link
                  to='/contact-me'
                  className={`${
                    location.pathname === '/contact-me' ? 'font-bold text-accent' : ''
                  } block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50`}
                  role='menuitem'
                >
                  Contact me
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
